import { __DEV__, isFunction } from './assertion';

export function runIfFn<T, U>(valueOrFn: T | ((...fnArgs: U[]) => T), ...args: U[]): T {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}

export function once(fn?: Function | null) {
  let result: any;

  return function func(this: any, ...args: any[]) {
    if (fn) {
      result = fn.apply(this, args);
      // eslint-disable-next-line no-param-reassign
      fn = null;
    }

    return result;
  };
}

export const noop = () => {};

type MessageOptions = {
  condition: boolean;
  message: string;
};

export const warn = once((options: MessageOptions) => {
  const { condition, message } = options;
  if (condition && __DEV__) {
    console.warn(message);
  }
});

export const error = once((options: MessageOptions) => {
  const { condition, message } = options;
  if (condition && __DEV__) {
    console.error(message);
  }
});
